import { render, staticRenderFns } from "./referrers-table.vue?vue&type=template&id=e6d91ea2"
import script from "./referrers-table.vue?vue&type=script&lang=js"
export * from "./referrers-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports